import {
  COUNTRIES,
  ALLOWED_AGES,
  ALLOWED_HEIGHTS,
  ALLOWED_WEIGHTS,
  ACCOUNT_CREATED_ON_DATE_RANGES
} from "../../../../../../constants/user-profile";
import i18n from "../../../../../../constants/i18n";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../../core/et3-input/et3-text-input";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import ET3Div from "../../../../../../core/et3-div";
import Et3Picker from "../../../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../../../TypesNEW";
import GetUserButton from "../../GetUserButton";
import {
  SEARCH_FORM_BUTTON_TOP_OFFSET,
  SEARCH_FORM_FIELD_GAP,
  SEARCH_FORM_ROW_GAP
} from "../../search-form-constants";

const CriteriaForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const userAdvancedStore = getUserAdvancedStore();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="row"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        flexWrap: "wrap",
        gap: `${SEARCH_FORM_ROW_GAP * unitY}px ${SEARCH_FORM_FIELD_GAP * unitX}px`
      }}
      onClick={() => {}}
    >
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        icon={faComment}
        type={"text"}
        label={i18n.get("USER_NAME")}
        placeHolder={i18n.get("USER_NAME")}
        value={userAdvancedStore.criteriaSearchUserName.get()}
        onChoose={(value: string) => {
          userAdvancedStore.setCriteriaSearchUserName(`${value}`);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <Et3Picker
        label={i18n.get("NATIONALITY")}
        options={COUNTRIES()}
        value={userAdvancedStore.criteriaSearchNationality.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          userAdvancedStore.setCriteriaSearchNationality(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Picker
        label={i18n.get("COUNTRY_OF_RESIDENCE")}
        options={COUNTRIES()}
        value={userAdvancedStore.criteriaSearchResidenceCountry.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          userAdvancedStore.setCriteriaSearchResidenceCountry(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Picker
        label={i18n.get("AGE")}
        options={ALLOWED_AGES}
        value={userAdvancedStore.criteriaSearchAge.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          userAdvancedStore.setCriteriaSearchAge(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Picker
        label={i18n.get("HEIGHT")}
        options={ALLOWED_HEIGHTS}
        value={userAdvancedStore.criteriaSearchHeight.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          userAdvancedStore.setCriteriaSearchHeight(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Picker
        label={i18n.get("WEIGHT")}
        options={ALLOWED_WEIGHTS}
        value={userAdvancedStore.criteriaSearchWeight.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          userAdvancedStore.setCriteriaSearchWeight(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Picker
        label={i18n.get("ACCOUNT_CREATED_ON")}
        options={ACCOUNT_CREATED_ON_DATE_RANGES}
        value={userAdvancedStore.criteriaSearchAccountCreatedOn.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          userAdvancedStore.setCriteriaSearchAccountCreatedOn(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"textarea"}
        icon={faComment}
        label={i18n.get("CRITERIA_DESCRIPTION")}
        placeHolder={i18n.get("CRITERIA_DESCRIPTION")}
        value={userAdvancedStore.criteriaSearchDescription.get()}
        onChoose={(value: string) => {
          userAdvancedStore.setCriteriaSearchDescription(`${value}`);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"textarea"}
        icon={faComment}
        label={i18n.get("CRITERIA_PEER_DESCRIPTION")}
        placeHolder={i18n.get("CRITERIA_PEER_DESCRIPTION")}
        value={userAdvancedStore.criteriaSearchPeerDescription.get()}
        onChoose={(value: string) => {
          userAdvancedStore.setCriteriaSearchPeerDescription(`${value}`);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          width: "auto",
          flexShrink: 0,
          marginTop: SEARCH_FORM_BUTTON_TOP_OFFSET * unitY
        }}
        onClick={() => {}}
      >
        <GetUserButton />
      </ET3Div>
    </ET3Div>
  );
});

export default CriteriaForm;
